<template>
    <div>
        <div class="rules__header rules__header-staff rules__header-section">
            <div class="text-size-18 text-bold rules__header-wrapper">
                <div class="rules__header-right">
					<div class="text-uppercase text-size-xs text-color-grey text-normal text-center" style="width: 140px;">
						тип договора
					</div>
					<div class="text-uppercase text-size-xs text-color-grey text-normal text-center mr8" style="width: 140px;">
						ставка
					</div>
					<div class="text-uppercase text-size-xs text-color-grey text-normal" style="width: 140px;">
						примечание
					</div>
                </div>
            </div>
        </div>
        <div class="content">

            <div class="container  staff-container" v-if="isLoad">
                <div class="nothing-found nothing-found__settings" v-if="usersGrouped.length === 0">
                    <svg class="big-icon" >
                        <use xlink:href="@/assets/img/big-icons-sprite.svg#emoji-search-2"></use>
                    </svg>
                    <div class="text-size-l text-bold mt16">
                    Здесь пока ничего нет...
                    </div>
                    <div class="text-size-m mt4">Срочно сделайте что-нибудь, чтобы здесь что-нибудь было!</div>
                </div>
                <div class="staff-list" v-else>
                    <div class="staff-item" v-for="(group, index) in usersGrouped" :key="'group'+group.id">
                        <div class="name">
                            {{group.name}}
                        </div>
                        <div class="workers-list admin-access">
                            <div class="worker" v-for="(user, indexUser) in group.users" :key="user.id">
								<span v-if="tumblers.schemeEditable.value" class="i-wrapper" @click="openSchemeWorker(user)">
									<span class="pencil"></span>
									<span class="pencil-active"></span>
								</span>
                                <div class="worker-name mr8" :style="{'width': '280px'}">
                                    <span class="text-size-s">{{user.name}}</span>
                                </div>
								<div class="text-size-s text-center" :style="{'width': '140px'}">
                                    {{ user.scheme.type }}
                                </div>
								<div class="text-size-s text-center mr8" :style="{'width': '140px'}">
                                    {{ user.scheme.rate }}
                                </div>
								<div class="text-size-s" :style="{'width': 'auto'}" v-if="user.scheme.note && user.scheme.note.length < 67">
									{{user.scheme.note}}
                                </div>
								<tooltip
									:direction="'bottom-right-direction'"
									:isBtnClose="false"
									:add-style="{width: 400 + 'px'}"
									:isChangeablePos="false"
									v-else-if="user.scheme.note" >
									<span slot="tooltipBtn">
										<a href="javascript:void(0);" class="text-size-s nowrap" :style="{'width': '403px', 'display': 'block'}">
											{{user.scheme.note}}
										</a>
									</span>

									<div slot="tooltipContent">
										<div class="text-size-s">
											{{user.scheme.note}}
										</div>
									</div>
								</tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <popup :is-set-styled="false" :show="popups.schemeWorker.show" :name="popups.schemeWorker.name" :width="800" :add-class="'add-worker'">
            <scheme-worker></scheme-worker>
        </popup>
    </div>
</template>


<script>
    import {mapState} from 'vuex';
    import Popup from '@/components/modal/Popup.vue';
    import StaffGroup from '@/components/modal/rules/StaffGroup.vue';
    import RemoveStaffGroupError from '@/components/modal/rules/RemoveCatError.vue';
    import SchemeWorker from '@/components/modal/rules/SchemeWorker.vue';
    import Tooltip from '@/components/Tooltip.vue';
    import draggable from '@/helpers/vuedraggable.js';
    import InputSelect from '@/components/forms/InputSelect.vue';
    import InputSelectNew from '@/components/forms/InputSelectNew.vue';
    import RightRadioSelect from '@/components/forms/RightRadioSelect.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import Tumbler from '@/components/Tumbler.vue';

    export default {
        metaInfo() {
            return {
                title: 'РЕГЛАМЕНТЫ И ПРАВИЛА',
                titleTemplate: this.$store.state.options.titleTemplate
            }
        },
        name: 'SectionDetail',
        components: {
            Popup,
            StaffGroup,
            RemoveStaffGroupError,
            Tooltip,
            draggable,
            SchemeWorker,
            InputSelect,
            InputSelectNew,
            SubmitBtn,
            Tumbler,
            RightRadioSelect
        },
        data: function(){
            return {
                options: [
                  {name: '<span class=text-color-orange2>Читатель</span>', id: 1},
                  {name: '<span class=text-color-green>Редактор</span>', id: 2},
                  {name: '<span class=text-color-dark-blue>Модератор</span>', id: 28},
                  {name: '<span>Нет доступа</span>', id: 0}
                ],
                drag: false,
                kickUnReadAllBtnType: 'normal',
                kickActive: false,
                form: {
                    selectAccess: {
                        id: 2,
                        error: false,
                    },
                },
                isLoad: false,
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                topSections: state => state.rules.topSections,
                usersGrouped: state => state.rulesStaff.usersByDepartmentList,
                tumblers: state => state.rules.tumblers,
            }),
            getCurrentTopSect: function () {
                if(this.topSections.length > 0 && this.$route.params.id){
                    return this.$store.getters['rules/getCurrentTopSect'](this.$route.params.id);
                }
            }
        },
        methods:{
            accessTitle(rights) {
              let titles = {
                'W': 'Редактор',
                'R': 'Читатель',
                'C': 'Модератор',
              }

              return titles[rights];
            },
            accessClass(rights) {
              let classes = {
                'W': 'editor',
                'R': 'reader',
                'C': 'chief',
              }

              return classes[rights];
            },
            getCurrentUserRights: function (user) {
              let rights = {
                    'W': '2',
                    'R': '1',
                    'C': '28',
                  },
                  result = 0;

              if (rights[user.rights[this.getCurrentTopSect.id]]) {
                result = rights[user.rights[this.getCurrentTopSect.id]];
              }

              return result;
            },
            changeAccess: function(event, index, indexUser){
                this.$store.dispatch('rulesStaff/setUserSectRight',{val: event, index: index, indexUser: indexUser, curSect: this.getCurrentTopSect.id});
                //this.$store.commit('rulesStaff/setUserSectRight',{val: event, index: index, indexUser: indexUser, curSect: this.getCurrentTopSect.id});
            },
            setValue(value, index){
                this.$store.commit('rulesStaff/setUsersByDepartmentListByIndex', {
                    items: value,
                    index: index
                });
            },
            up: function(index){
                this.$store.dispatch('rulesStaff/setMoveGroup', {index: index, direction: 'up'});
            },
            down: function(index){
                this.$store.dispatch('rulesStaff/setMoveGroup', {index: index, direction: 'down'});
            },
            openStaffGroup: function (group = []) {
                this.$store.commit('rulesStaff/setEditGroup', group);
                this.$store.dispatch('popups/open', {name: this.popups.staffGroup.name});
            },
            openSchemeWorker: function (user = []) {
                this.$store.commit('rulesStaff/setEditUser', user);
                this.$store.dispatch('popups/open', {name: this.popups.schemeWorker.name});
            },
            dragSave: function (index) {
                if (this.drag) {
                    this.$store.dispatch('rulesStaff/setUserSort', {index: index});
                    this.drag = false;
                }
            },
            dragStart: function (index) {
                this.curDrugGroupIndex = index;
            },
            dragStatus: function (e) {
                this.drag = true;
            },
            openSectionAdd: function (cat) {
                this.$store.commit('rules/setEditSection',cat);
                this.$store.dispatch('popups/open', {name: this.popups.sectionAdd.name});
            },
            kickUnRead(id){
                this.$store.commit('rulesStaff/kickUnReadBtnType', {id: id,type: 'load'});
                this.$store.dispatch('rulesStaff/kickUnRead', {id: id}).then(()=>{
                    this.$store.commit('rulesStaff/kickUnReadBtnType', {id: id,type: 'normal'});
                });
            },
            kickUnReadAll(){
                this.kickUnReadAllBtnType = 'load';
                this.$store.dispatch('rulesStaff/kickUnReadAll').then(()=>{
                    this.kickUnReadAllBtnType = 'normal';
                });
            }
        },
        mounted() {
            //this.$store.commit('rules/tumblerOff', this.tumblers.editable.name);
            this.$store.dispatch('rulesStaff/getUsersByDepartment',{withScheme: 1}).then(()=>{
                this.isLoad = true;
            });
        },
    }
</script>
